<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="绑定设备"
      edit-title
      id-key="DpId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.bind"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      close-on-saved
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="模拟器编号" prop="SimulatorNo">
          <span>{{ data.SimulatorNo }}</span>
        </el-form-item>
        <el-form-item label="绑定设备" prop="ImeiMac">
          <el-input
            v-model="data.ImeiMac"
            placeholder="请选择设备"
            readonly
            @focus="openCarDialog"
          ></el-input>
        </el-form-item>
      </template>
    </common-dialog>
    <device-dialog
      ref="deviceDialog"
      in-dialog
      selectable
      @select="setDevice"
      :show-tree="false"
    />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/op/simulator";
import deviceDialog from "@/components/operate/device/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    deviceDialog,
  },
  data() {
    return {
      data: {
        CarNo: "",
        SimulatorId: 0,
        SimulatorNo: "",
        DeviceId: null,
        DeviceNo: "",
        ImeiMac: "",
        DpId: "",
      },
      api,
      rules: {
        ImeiMac: [{ required: true, message: "请选择绑定设备" }],
      },
    };
  },
  methods: {
    onenDpDialog() {},
    onEditOpened(data) {
      console.log("data", this.data);
    },
    openCarDialog() {
      this.$refs.deviceDialog.open().then((that) => {
        that.getData({
          DpId: this.data.DpId,
          RecordStatus: 3,
          DeviceType: "模拟训练计时终端",
          BindSimulator: false,
        });
      });
    },
    setDevice(e) {
      this.data.DeviceId = e.DeviceId;
      this.data.DeviceNo = e.DeviceNo;
      this.data.ImeiMac = e.ImeiMac;
    },
    onClosed() {},
  },
};
</script>